import React from 'react';
import { motion } from 'framer-motion';
import { CalendarCheck, UserCheck, TrendingUp } from 'lucide-react';
import { howItWorks } from '../mockData';
import Lottie from 'lottie-react';

const iconMap = {
  'calendar-check': CalendarCheck,
  'user-check': UserCheck,
  'trending-up': TrendingUp
};

const HowItWorks = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-cyan-50 via-blue-50 to-white">
      <div className="container mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            How It <span className="text-cyan-600">Works</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Start your learning journey in just three simple steps
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-12 relative">
          {/* Connection lines for desktop */}
          <div className="hidden md:block absolute top-1/4 left-1/4 right-1/4 h-1 bg-gradient-to-r from-cyan-300 via-blue-300 to-teal-300" />
          
          {howItWorks.map((step, index) => {
            const Icon = iconMap[step.icon];
            return (
              <motion.div
                key={step.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.2, duration: 0.6 }}
                className="relative"
              >
                <div className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-shadow duration-300 h-full relative z-10">
                  {/* Step number badge */}
                  <div className="absolute -top-4 -right-4 w-12 h-12 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full flex items-center justify-center shadow-lg">
                    <span className="text-white font-bold text-lg">{index + 1}</span>
                  </div>

                  <div className="w-20 h-20 bg-gradient-to-br from-cyan-100 to-blue-100 rounded-2xl flex items-center justify-center mb-6 mx-auto">
                    <Icon className="w-10 h-10 text-cyan-600" />
                  </div>

                  <div className="text-center space-y-3">
                    <span className="text-sm font-semibold text-cyan-600 uppercase tracking-wide">
                      {step.step}
                    </span>
                    <h3 className="text-2xl font-bold text-gray-900">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;